import "core-js/stable";

import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import { render } from "react-dom";

import AppRouter, { createRootComponent } from "@tsp/app";
import { fetchEnvClient } from "@tsp/env/client";

(async () => {
  const history = createBrowserHistory();

  const env = await fetchEnvClient();

  const Wrapper = createRootComponent({ history, env });

  render(
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      dateFormats={{
        keyboardDate: "dd.MM.yyyy",
        keyboardDateTime: "dd.MM.yyyy HH:mm",
        keyboardDateTime24h: "dd.MM.yyyy HH:mm",
        fullDate: "dd.MM.yyyy",
        fullTime24h: "HH:mm",
        weekdayShort: "iiiii",
      }}
    >
      <Wrapper>
        <CssBaseline />
        <ConnectedRouter history={history}>
          <AppRouter />
        </ConnectedRouter>
      </Wrapper>
    </LocalizationProvider>,
    document.getElementById("root"),
  );
})();
